module.exports = __webpack_public_path__ + "media/site/images/logo-white-75d3e94360e6eded79dacb5a4bb6cf1f.svg";